import React from 'react';
import { styled, Typography } from '@mui/material';
import AppLogo from '../assets/AMOLogo.svg';
import { useTranslation } from 'react-i18next';
import { StyledRowBox } from '../theme/StyledElements';

const StyledHeader = styled(StyledRowBox)(() => ({
    bottom: '0px',
    left: '0px',
    right: '0px',
    width: '100vw',
    padding: '0px 100px',
    margin: '20px 0px'
}));

const StyledCompanyHeader = styled(Typography)(() => ({
    padding: '10px',
    letterSpacing: '0px',
    color: '#134C03',
    textDecoration: 'none',
    marginTop: '10px',
    fontWeight: 500
}));

const StyledImage = styled('img')(() => ({
    height: '62px',
    width: '80px',
    margin: '3px'
}));

interface GeneralNavbarProps {
    isBottomBorderRequired?: boolean;
}

export function GeneralNavbar({ isBottomBorderRequired }: GeneralNavbarProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <StyledHeader
            style={{
                borderBottom: isBottomBorderRequired ? '1px solid #E37F1E' : '',
                height: '80px'
            }}>
            <StyledImage src={AppLogo} />
            <StyledCompanyHeader variant="h1">{t('companyName')}</StyledCompanyHeader>
        </StyledHeader>
    );
}
